import { Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Donate from "./pages/Donate";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/donate" element={<Donate />} />
      </Routes>
    </div>
  );
}

export default App;
